module.exports = __webpack_public_path__ + "img/zhan1.caa1f64f.png";